
import { postData } from '../utils/ajax-utils';
import initSlimSelect, { SlimSelectHTMLElement } from '../utils/slim-select';

declare const registerType: string;

export default function initRegister() {
    const $register = document.querySelector<HTMLElement>('.register-contact-edit');

    if ($register) {
        new RegisterPage($register);
    }
}

export class RegisterPage {
    $container: HTMLElement;
    $activitySelector: SlimSelectHTMLElement|null;
    $subActivitySelector: SlimSelectHTMLElement|null;

    constructor($container: HTMLElement) {
        this.$container = $container;
        const $password = this.$container.querySelector<HTMLInputElement>('input[type="password"]:not(.edit-profile-old_password)');
        const $passwords = this.$container.querySelectorAll('input[type="password"]:not(.edit-profile-old_password)') as NodeListOf<HTMLInputElement>;
        const $form = this.$container.querySelector<HTMLFormElement>('form');
        this.$activitySelector = this.$container.querySelector<SlimSelectHTMLElement>('.js-register-form-activity-area-field');
        this.$subActivitySelector = this.$container.querySelector<SlimSelectHTMLElement>('.js-form-activity-sub-area-field');

        if ($form) {
            this.formStepsHandler($form);
            this.stepValidation('.js-register-form-step-1');
            this.stepValidation('.js-register-form-step-2');

            if ($password) {
                this.isValidPasswordChecker($passwords);
            }

            if ($passwords) {
                this.isEqualPasswordsChecker($passwords);
            }

            if (this.$activitySelector && this.$subActivitySelector) {
                // On vide le champ "secteur d'activité" par défaut
                if (this.$activitySelector.dataset.defaultClear) {
                    this.$activitySelector.slim.set('');
                }

                this.filterActivitySelect();

                this.$activitySelector.addEventListener('change', () => {
                    // Activation de tous les sous-domaines d'activité
                    this.$subActivitySelector?.querySelectorAll('option').forEach(option => {
                        option.style.display= '';
                    });

                    this.filterActivitySelect();
                });
            }
        }
    }

    /**
     * Envoi les informations de l'étape courante à GTM
     * 
     * @param {number} formStepsNum
     * @param {string} registerType
     * 
     * @return {void}
     */
    sendStepGtmEvent(formStepsNum: number, registerType: string) : void {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'inscription_step_funnel',
            'step_funnel': `form-step-${formStepsNum + 1}`,
            'inscription_type': `inscription ${registerType}`
        });
    }

    /**
     * Gère la navigation des étapes du formulaire
     * 
     * @param $form
     * 
     * @return {void}
     */
    formStepsHandler($form: HTMLFormElement) : void {
        const prevBtns = this.$container.querySelectorAll<HTMLElement>('.form-prev-btn');
        const nextBtns = this.$container.querySelectorAll<HTMLElement>('.form-next-btn');
        const formSteps = this.$container.querySelectorAll<HTMLElement>('.form-group');
        const currentFormStepsPagination = this.$container?.querySelector('.right-side-number-progression') as HTMLElement;
        const totalFormStepsPagination = this.$container?.querySelector<HTMLElement>('.right-side-number-total');

        // Gestion du nombre total de la pagination
        if (totalFormStepsPagination) {
            totalFormStepsPagination.innerText = `/${formSteps.length.toString()}`;
        }

        let formStepsNum = 0;

        if (typeof registerType !== 'undefined') {
            this.sendStepGtmEvent(formStepsNum, registerType);
        }

        /**
         * Vérifie l'étape 1 de l'inscription
         * 
         * @return {Promise<boolean>}
         */
        const checkStep1 = async () : Promise<boolean> => {
            const $step1Container = this.$container.querySelector<HTMLElement>('.js-register-form-step-1');

            const $emailField = $step1Container?.querySelector<HTMLInputElement>('.js-register-form-email-field');
            const $lastnameField = $step1Container?.querySelector<HTMLInputElement>('.js-register-form-lastname-field');
            const $firstnameField = $step1Container?.querySelector<HTMLInputElement>('.js-register-form-firstname-field');
            const $phoneField = $step1Container?.querySelector<HTMLInputElement>('.js-register-form-phone-field[required]');
            const $functionField = $step1Container?.querySelector<HTMLInputElement>('.js-register-form-function-field[required]');

            type AjaxDataType = {
                action: string,
                lastname: string,
                firstname: string,
                email: string,
                phone?: string,
                function?: string,
            };

            const ajaxData: AjaxDataType = {
                action: 'check_register_form_step_1',
                lastname: $lastnameField?.value || '',
                firstname: $firstnameField?.value || '',
                email: $emailField?.value || '',
            };

            if ($phoneField) {
                ajaxData.phone = $phoneField?.value || '';
            }

            if ($functionField) {
                ajaxData.function = $functionField?.value || '';
            }

            const $errorsContainer = this.$container.querySelector<HTMLElement>('.js-register-form-errors-container');
            const $errors = document.createElement('ul');
            $errors.classList.add('error');

            if ($errorsContainer) {
                $errorsContainer.innerHTML = '';
                $errorsContainer.append($errors);
            } else {
                $form.append($errors);
            }

            $form.classList.add('loading');

            return postData(script_var.ajax_url, ajaxData).then(response => {
                if (response.success) {
                    return true;
                }

                const $error = document.createElement('li');
                //$error.innerHTML = response.data;

                $errors.append($error);
                if (response.data.message) {
                    console.log('test')
                    const $field = document.querySelector('.' + response.data.field);
                    document.querySelectorAll('ul.error').forEach(error => error.remove());
                    document.querySelectorAll('.error').forEach(error => error.classList.remove('error'));
                    document.querySelectorAll('.has-error').forEach(error => error.classList.remove('has-error'));
                    $field?.classList.add('error');
                    $field.parentElement?.insertAdjacentHTML('beforeend','<ul class="error"><li>' +response.data.message+ '</li></ul>');
                    $field.parentElement?.classList.add('has-error');
                } else {
                    $error.innerHTML = response.data;
                }

                return false;
            }).catch(() => {
                const $error = document.createElement('li');
                $error.innerHTML = 'Une erreur est survenue. Veuillez réessayer plus tard.';

                $errors.append($error);

                return false;
            }).finally(() => {
                $form.classList.remove('loading');

                return false;
            });
        }

        /**
         * Vérifie l'étape 2 de l'inscription
         *
         * @return {Promise<boolean>}
         */
        const checkStep2 = async () : Promise<boolean> => {
            const $step2Container = this.$container.querySelector<HTMLElement>('.js-register-form-step-2');

            const $isTeledeclarantFieldsContainer = $step2Container?.querySelector<HTMLElement>('.js-register-form-is-teledeclarant-fields');
            const $isTeledeclarantField = $isTeledeclarantFieldsContainer?.querySelector<HTMLInputElement>('input:checked');
            const $cotisantNumberField = $step2Container?.querySelector<HTMLInputElement>('.js-register-form-cotisant-number-field');
            const $activityAreaField = $step2Container?.querySelector<HTMLSelectElement>('.js-register-form-activity-area-field');
            const $companyNameField = $step2Container?.querySelector<HTMLInputElement>('.js-register-form-company-field');
            const $sirenField = $step2Container?.querySelector<HTMLInputElement>('#register_professional_form_company_siren');

            type AjaxDataTypeStep2 = {
                action: string,
                cotisant_number?: string,
                is_teledeclarant?: string,
                activity_area?: string,
                company_name?: string,
                company_siren?: string,
            };

            const ajaxDataStep2: AjaxDataTypeStep2 = {
                action: 'check_register_form_step_2',
            };

            if ($cotisantNumberField) {
                ajaxDataStep2.cotisant_number = $cotisantNumberField?.value || '';
            }

            if ($isTeledeclarantFieldsContainer) {
                ajaxDataStep2.is_teledeclarant = $isTeledeclarantField?.value || '';
            }

            if ($activityAreaField) {
                ajaxDataStep2.activity_area = $activityAreaField?.value || '';
            }

            if ($companyNameField) {
                ajaxDataStep2.company_name = $companyNameField?.value || '';
            }

            if ($sirenField) {
                ajaxDataStep2.company_siren = $sirenField?.value || '';
            }

            const $errorsContainer = this.$container.querySelector<HTMLElement>('.js-register-errror-step2');
            const $errors = document.createElement('ul');
            $errors.classList.add('error');

            if ($errorsContainer) {
                $errorsContainer.innerHTML = '';
                $errorsContainer.append($errors);
            } else {
                $form.append($errors);
            }

            $form.classList.add('loading');

            return postData(script_var.ajax_url, ajaxDataStep2).then(response => {
                if (response.success) {
                    return true;
                }

                const $error = document.createElement('li');
                if (response.data.message) {
                    const $field = document.getElementById(response.data.field);
                    document.querySelectorAll('ul.error').forEach(error => error.remove());
                    document.querySelectorAll('.error').forEach(error => error.classList.remove('error'));
                    document.querySelectorAll('.has-error').forEach(error => error.classList.remove('has-error'));
                    $field?.classList.add('error');
                    $field.parentElement?.insertAdjacentHTML('beforeend','<ul class="error"><li>' +response.data.message+ '</li></ul>');
                    $field.parentElement?.classList.add('has-error');
                } else {
                    $error.innerHTML = response.data;
                }


                $errors.append($error);

                return false;
            }).catch(() => {
                const $error = document.createElement('li');
                $error.innerHTML = 'Une erreur est survenue. Veuillez réessayer plus tard.';

                $errors.append($error);

                return false;
            }).finally(() => {
                $form.classList.remove('loading');

                return false;
            });
        }

        const updateFormSteps = () => {
            const nextStep = formSteps[formStepsNum];

            if (nextStep) {
                formSteps.forEach((formStep) => {
                    if (formStep.classList.contains('form-group--active')) {
                        formStep.classList.remove('form-group--active');
                    }
                });

                nextStep.classList.add('form-group--active');
                nextStep.querySelector<HTMLElement>('input:not([type="search"]):not([type="checkbox"])')?.focus();
                // Gestion de la pagination
                if (currentFormStepsPagination) {
                    currentFormStepsPagination.innerText = (formStepsNum + 1).toString();
                }

                if (typeof registerType !== 'undefined') {
                    this.sendStepGtmEvent(formStepsNum, registerType);
                }
            }
        }

        // Passage à l'étape suivante lorsqu'on appuie sur la touche "Enter"
        $form.addEventListener('keypress', evt => {
            if (evt.key !== 'Enter') {
                return;
            }

            if ((formStepsNum + 1) < formSteps.length) {
                evt.preventDefault();
                nextBtns[formStepsNum]?.click();
            }
        });

        nextBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                if (formStepsNum === 0) {
                    checkStep1().then(isValid => {
                        if (isValid) {
                            formStepsNum++;
                            updateFormSteps();
                            window.scrollTo(0, 0);
                        }
                    });
                } else if (formStepsNum === 1) {
                    checkStep2().then(isValid => {
                        if (isValid) {
                            formStepsNum++;
                            updateFormSteps();
                            window.scrollTo(0, 0);
                        }
                    });
                } else {
                    formStepsNum++;
                    updateFormSteps();
                    window.scrollTo(0, 0);
                }
            });
        });

        prevBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                formStepsNum--;
                updateFormSteps();
                window.scrollTo(0, 0);
            });
        });
    }

    /**
     * Check si le mot de passe est valide( min 8 car, 1 maj, 1 min, 1 car spé)
     * 
     * @param {HTMLInputElement} $password
     *
     * @return {void}
     */
    isValidPasswordChecker($password:  NodeListOf<HTMLInputElement>) : void {
        $password[0].addEventListener('keyup',() => {
            const validPassword = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})');
            const validationBar = this.$container.querySelector('.form-password-validation-bar-progress');
            const validMessage = this.$container.querySelector('.form-password-validation-message--ok');
            const invalidMessage = this.$container.querySelector('.form-password-validation-message--not-ok');
            const $pwdContainer = document.querySelector('.form-group.form-group--active .btn--lg.ripplet[type="submit"]');

            if (validPassword.test($password[0].value)) {
                if (validMessage) {
                    validMessage.classList.add('form-password-validation-message--active');

                    if (invalidMessage) {
                        invalidMessage.classList.remove('form-password-validation-message--active');
                    }
                }
                $pwdContainer.removeAttribute('disabled')
                if (validationBar) {
                    validationBar.classList.add('ok');
                    validationBar.classList.remove('not-ok');
                }
            } else if (!validPassword.test($password[0].value)) {
                if (invalidMessage) {
                    invalidMessage.classList.add('form-password-validation-message--active');

                    if (validMessage) {
                        validMessage.classList.remove('form-password-validation-message--active');
                    }
                }
                $pwdContainer.setAttribute('disabled', true)
                if (validationBar) {
                    validationBar.classList.add('not-ok');
                    validationBar.classList.remove('ok');
                }
            }
        });
    }

    /**
     * Check si le mot de passe est egal à la confirmation du mdp
     * 
     * @param {NodeListOf<HTMLInputElement>} $passwords
     *
     * @return {void}
     */
    isEqualPasswordsChecker($passwords: NodeListOf<HTMLInputElement>) : void {
        const firstPassword = $passwords[0];
        const secondPassword = $passwords[1];
        const equalPasswordsMessage = document.querySelector('.form-password-validation-matching');

        $passwords.forEach((password: HTMLInputElement) => {
            password.addEventListener('keyup', () => {
                const $pwdContainer = document.querySelector('.form-group.form-group--active .btn--lg.ripplet[type="submit"]');

                if (firstPassword.value !== secondPassword.value && equalPasswordsMessage) {
                    equalPasswordsMessage.classList.add('form-password-validation-matching--active');
                    $pwdContainer.setAttribute('disabled', true)
                } else if (firstPassword.value === secondPassword.value && equalPasswordsMessage) {
                    const validPassword = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})');

                    equalPasswordsMessage.classList.remove('form-password-validation-matching--active');
                    if (validPassword.test(secondPassword.value)) {
                        $pwdContainer.removeAttribute('disabled')
                    }
                }
            });
        });
    }

    /**
     * Filtre les sous-domaines d'activité en fonction du domaine d'activité principal sélectionné
     *
     * @return {void}
     */
    filterActivitySelect() : void {
        if (!this.$activitySelector || !this.$subActivitySelector) {
            return;
        }

        // Enregistrement des valeurs sélectionnées
        let selected = this.$subActivitySelector.slim.selected() as string[];
        const possibleSelected: string[] = [];

        this.$subActivitySelector.slim.set([]);

        const activity = this.$activitySelector.value;
        const activityValue = parseInt(activity);
        const subActivities = this.$subActivitySelector.querySelectorAll('option');

        subActivities.forEach(subActivity => {
            const subActivityValueSectors = subActivity.getAttribute('data-activity-area') || '';
            const subactivityValues = JSON.parse(subActivityValueSectors);

            // Désactivation du sous-domaine d'activité s'il n'est pas lié au sous-domaine principal
            if (!subactivityValues.includes(activityValue)) {
                subActivity.style.display = 'none';
            } else {
                possibleSelected.push(subActivity.value);
            }
        });

        // Re-création du slimSelect avec les nouvelles valeurs
        this.$subActivitySelector.slim.destroy();
        this.$subActivitySelector.classList.remove('mounted');

        initSlimSelect();

        // Application des valeurs sélectionnées si elles peuvent l'être
        selected = selected.filter(choice => possibleSelected.includes(choice));
        this.$subActivitySelector.slim.set(selected);
    }

    stepValidation(containerSelector: string) : void {
        const $requierdFields : NodeListOf<HTMLInputElement> = document.querySelectorAll(containerSelector + ' [required="required"]');
        const $nextButton : HTMLInputElement = document.querySelector(containerSelector + ' .form-next-btn');


        $requierdFields.forEach(($requierdField) => {
            ['change', 'keyup', 'focus', 'blur'].forEach(event => $requierdField.addEventListener(event, () => {
                let formValid = true;

                $requierdFields.forEach(($field) => {
                    if ($field.value == '') {
                        formValid = false;
                        return false;
                    }
                })

                if (formValid) {
                    $nextButton.removeAttribute('disabled');
                } else {
                    $nextButton.setAttribute('disabled', true);
                }
            }));
        })
    }
}
